import {
  put, takeEvery, select,
} from 'redux-saga/effects';
import {
  ACT_INSTANCES_FETCH_CONTEXTS_INIT_ACTION,
  ACT_INSTANCES_GET_CONTEXT_INIT_ACTION,
  ACT_INSTANCES_ADD_CONTEXT_INIT_ACTION,
  ACT_INSTANCES_DELETE_CONTEXT_INIT_ACTION,
  ACT_INSTANCES_UPDATE_CONTEXT_FILTERS,
} from '../../constants/actions';
import {
  addContextSuccessAction,
  deleteContextSuccessAction,
  fetchContextsSuccessAction,
  getContextSuccessAction,
} from '../../actions/instances/context';
import Api from '../../services/Api';

function* fetchContexts() {
  const { filters } = yield select(state => state.contexts);
  let query = '';
  if (filters.types.length > 0) {
    query += filters.types.map(type => `&types_ids[]=${type}`);
  }
  if (filters.dynasties.length > 0) {
    query += filters.dynasties.map(dynasty => `&dynasties_ids[]=${dynasty}`);
  }
  if (filters.tags.length > 0) {
    query += filters.tags.map(tag => `&tags_ids[]=${tag}`);
  }
  if (filters.cities.length > 0) {
    query += filters.cities.map(city => `&cities_ids[]=${city}`);
  }
  const { status, data } = yield Api.get(`instances/building-contexts?per_page=50${query}`, false);
  if (status === 200) {
    yield put(fetchContextsSuccessAction(data.data));
  }
}

function* getContext(action) {
  const { status, data } = yield Api.get(`instances/building-contexts/${action.payload}`, false);
  if (status === 200) {
    yield put(getContextSuccessAction(data));
  }
}

function* addContext(action) {
  const { status, data } = yield Api.post('instances/building-contexts', action.payload, false);
  if (status === 200) {
    yield put(addContextSuccessAction(data));
  }
}

function* deleteContext(action) {
  const { status } = yield Api.delete(`instances/building-contexts/${action.payload}`, false);
  if (status === 204) {
    yield put(deleteContextSuccessAction());
  }
}

export default function* contextsSagas() {
  yield takeEvery([
    ACT_INSTANCES_FETCH_CONTEXTS_INIT_ACTION,
    ACT_INSTANCES_UPDATE_CONTEXT_FILTERS,
  ], fetchContexts);
  yield takeEvery(ACT_INSTANCES_GET_CONTEXT_INIT_ACTION, getContext);
  yield takeEvery(ACT_INSTANCES_ADD_CONTEXT_INIT_ACTION, addContext);
  yield takeEvery(ACT_INSTANCES_DELETE_CONTEXT_INIT_ACTION, deleteContext);
}
